import {
  SET_ODD_API_RESPONSE,
  SET_ODD_RFI_USER_INFO,
  SET_USER_DOCUMENTS_INFO,
  SET_ODD_RFI_RESUME_ID,
  SET_ODD_RFI_SCREEN_NAME,
  SET_ODD_RFI_LOADING,
  SET_ODD_RFI_EDITED_USER_INFO,
  SET_ODD_RFI_EDITED_DOCUMENTS,
  SET_ODD_RFI_ADDRESS_CONFIG,
  SET_ODD_RFI_PENDING_VERIFICATION,
  SET_ODD_RFI_SELECTED_VERIFICATION_DOC,
  SET_ODD_RFI_POI_SUBMISSION,
  SET_ODD_RFI_POA_SUBMISSION,
  SET_ODD_RFI_POI_FILES,
  SET_ODD_RFI_POA_FILES,
  SET_ODD_RFI_POI_FAILED,
  SET_ODD_RFI_POA_FAILED,
  SET_ODD_RFI_QUEUE_INFO,
  SET_ODD_RFI_COUNTRY_OPTIONS,
  SET_ODD_RFI_ADDRESS_CHANGED,
  SET_ODD_RFI_POA_DATA
} from '@Redux/action-contants';

const INITIAL_STATE = {
  oddApiResponse: {},
  userInfo: {},
  userDocumentsInfo: [],
  // Captured off NextLinked's own .next pointer the moment the cursor lands on the ODD
  // item, so the carousel can jump straight back to it across the /rfi <-> /rfi/odd
  // route boundary instead of restarting the queue from position 1.
  resumeAtRfiId: null,
  currentScreen: 'all_information',
  isLoading: true,
  // Locally edited section values (e.g. address) that haven't been submitted to the
  // backend yet — kept apart from userInfo so the original API-sourced data isn't lost.
  editedUserInfo: null,
  // Locally edited document field values, keyed by document section name
  // (e.g. 'passport_details', 'driving_license') — kept apart from userDocumentsInfo.
  editedUserDocuments: null,
  // Country-specific address schema, cached once the address edit screen fetches it —
  // used to filter which address fields are actually relevant to display (userInfo
  // carries fields from every country's schema, not just the current one).
  addressConfig: null,
  // Set from the first RFI submission's response — which of poi/poa (if any) still
  // need to be re-collected before the follow-up submission can go through.
  pendingVerification: null,
  // The document type the user picked on the POI/POA verification doc-list screen —
  // consumed by the field-entry form to know which fields_json/document_code to use.
  selectedVerificationDocument: null,
  // Field values collected on the verification form, keyed by document_code, once the
  // user has (re)submitted their POI/POA document — merged into the follow-up /rfi call.
  poiSubmission: null,
  poaSubmission: null,
  // File blobs collected on the verification form, keyed by the FormData field name
  // referenced in poiSubmission/poaSubmission's file_name — held here so both survive
  // the POI → POA navigation and can ride together in the one follow-up /rfi call.
  poiFiles: null,
  poaFiles: null,
  // Set from the follow-up (poi/poa-included) submission's response — whether that
  // second hit is still reporting poi/poa as unresolved.
  poiFailed: false,
  poaFailed: false,
  // this ODD item's position within the user's overall RFI queue (0-based) and the
  // queue's total size — drives the "N of total" progress dots, same as normal RFIs.
  rfiQueueIndex: null,
  rfiQueueTotal: null,
  countryOptions: null,
  // HK ODD only — whether the address last saved on the address screen differs from the one
  // stored in the API; decides if the High Risk POA is asked for and submitted.
  addressChanged: false,
  // HK ODD High Risk only — the POA document type + file picked on the POA upload screen.
  poaData: null
};
export default function oddRfiReducer(state = INITIAL_STATE, action: { type: string; data: any }) {
  switch (action.type) {
    case SET_ODD_API_RESPONSE:
      return {
        ...state,
        oddApiResponse: action.data
      };
    case SET_ODD_RFI_USER_INFO:
      return {
        ...state,
        userInfo: action.data
      };
    case SET_USER_DOCUMENTS_INFO:
      return {
        ...state,
        userDocumentsInfo: action.data
      };
    case SET_ODD_RFI_RESUME_ID:
      return {
        ...state,
        resumeAtRfiId: action.data
      };
    case SET_ODD_RFI_SCREEN_NAME:
      return {
        ...state,
        currentScreen: action.data
      };
    case SET_ODD_RFI_LOADING:
      return {
        ...state,
        isLoading: action.data
      };
    case SET_ODD_RFI_EDITED_USER_INFO:
      return {
        ...state,
        editedUserInfo: action.data
      };
    case SET_ODD_RFI_EDITED_DOCUMENTS:
      return {
        ...state,
        editedUserDocuments: action.data
      };
    case SET_ODD_RFI_ADDRESS_CONFIG:
      return {
        ...state,
        addressConfig: action.data
      };
    case SET_ODD_RFI_PENDING_VERIFICATION:
      return {
        ...state,
        pendingVerification: action.data
      };
    case SET_ODD_RFI_SELECTED_VERIFICATION_DOC:
      return {
        ...state,
        selectedVerificationDocument: action.data
      };
    case SET_ODD_RFI_POI_SUBMISSION:
      return {
        ...state,
        poiSubmission: action.data
      };
    case SET_ODD_RFI_POA_SUBMISSION:
      return {
        ...state,
        poaSubmission: action.data
      };
    case SET_ODD_RFI_POI_FILES:
      return {
        ...state,
        poiFiles: action.data
      };
    case SET_ODD_RFI_POA_FILES:
      return {
        ...state,
        poaFiles: action.data
      };
    case SET_ODD_RFI_POI_FAILED:
      return {
        ...state,
        poiFailed: action.data
      };
    case SET_ODD_RFI_POA_FAILED:
      return {
        ...state,
        poaFailed: action.data
      };
    case SET_ODD_RFI_QUEUE_INFO:
      return {
        ...state,
        rfiQueueIndex: action.data?.index ?? null,
        rfiQueueTotal: action.data?.total ?? null
      };
    case SET_ODD_RFI_COUNTRY_OPTIONS:
      return {
        ...state,
        countryOptions: action.data
      };
    case SET_ODD_RFI_ADDRESS_CHANGED:
      return {
        ...state,
        addressChanged: action.data
      };
    case SET_ODD_RFI_POA_DATA:
      return {
        ...state,
        poaData: action.data
      };
    default:
      return state;
  }
}
